<template>
  <v-app-bar app clipped-left clipped-right>
    <v-toolbar-title
      class="no-padding"
      align="left"
      style="overflow: initial; width: 173px"
    >
      <img
        @click="getLogoImg"
        id="logo-img"
        :src="logo ? logo : '/newapalylogoblue.png'"
        class="apaly-pic pointer mr-16"
      />
    </v-toolbar-title>
    <v-divider class="header-divider-hide" vertical></v-divider>
    <div class="col-md-6 col-sm-6 header-hamb-icon mt-md-3 no-padding row">
      <i
        class="fas fa-bars top-2px"
        style="cursor: pointer; color: gray"
        @click="hideSideBar"
      ></i>

      <h2
        class="text-gray font-quicksand-semibold mb-4 ml-2 group-name"
        id="changeProDisplayName"
        @click="getDisplayName"
        v-html="displayName"
      ></h2>
    </div>
    <v-spacer />
    <div class="user-settings">
      <div class="font text-right font-quicksand-medium-12" v-if="user">
        {{ user.firstName }} {{ user.lastName }}
      </div>
      <div class="font-quicksand-medium-11" v-if="user">{{ user.email }}</div>
    </div>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn dark icon v-on="on" class="mr-1">
          <v-avatar size="40">
            <img
              style="object-fit: cover"
              id="profile-img"
              @click="changeProfileImg"
              :src="
                profileImg
                  ? profileImg
                  : 'https://www.pngkit.com/png/full/128-1280585_user-icon-fa-fa-user-circle.png'
              "
              alt="John"
            />
          </v-avatar>
        </v-btn>
      </template>
      <v-list width="150">
        <!-- <v-list-item class="p-0">
          <v-list-item-avatar>
            <img
              style="object-fit: cover"
              :src="
                profileImg
                  ? profileImg
                  : 'https://www.pngkit.com/png/full/128-1280585_user-icon-fa-fa-user-circle.png'
              "
              alt="John"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font" v-if="user"
              >{{ firstName }} {{ lastName }}
            </v-list-item-title>
            //<v-list-item-subtitle class="font" v-if="user">{{user.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider> -->

        <v-list-item
          v-for="(item, i) in userprofile"
          :key="i"
          color="primary"
        >
          <v-list-item-title class="pointer" @click="logout(item)">{{
            item.title
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import api from "../../../services/api";
export default {
  name: "Header",
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showLogo: true,
    showSearch: false,
    fav: true,
    displayName: "Super Admin",
    logo: "",
    profileImg: "",
    accountSettings: false,
    firstName: "",
    lastName: "",
    userprofile: [
      {
        title: "My Profile",
      },
      {
        title: "Logout",
      },
    ],
  }),
  computed: {
    user() {
      let user = {
        firstName: "",
        lastName: "",
        email: "",
      };
      if (localStorage.getItem("user")) {
        user = JSON.parse(localStorage.getItem("user"));
      }
      return user;
    },
  },
  created() {
    
  },
  methods: {

    getLogoImg(){},
    getDisplayName(){},

    changeProfileImg() {
      
    },
    hideSideBar() {
      this.$emit("expantSideBarOnHover");
    },
    logout(item) {
      if (item.title == 'My Profile') {
          this.$router.push("/superadmin/settings");
        
      } else {
        localStorage.clear();
        this.$cookies.remove("token");
        this.$router.replace("/login");
      
      }
    },
    showhideLogo: function () {
      this.showLogo = !this.showLogo;
    },
    searchbox: function () {
      this.showSearch = !this.showSearch;
    },
  },
};
</script>

<style>
</style>